const BrowserDetect = {
  dataOS: [
    { string: navigator.platform, subString: 'Win', identity: 'Windows' },
    { string: navigator.platform, subString: 'Mac', identity: 'macOS' },
    { string: navigator.userAgent, subString: 'iPhone|iPad|iPod', identity: 'iOS' }, // Combined iOS checks
    { string: navigator.userAgent, subString: 'Android', identity: 'Android' },
    { string: navigator.platform, subString: 'Linux', identity: 'Linux' },
  ],

  getBrowserInfo() {
    const ua = navigator.userAgent;
    const browserMatch = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i);
    const osMatch = this.dataOS.find((os) => ua.indexOf(os.subString) !== -1);

    const browser = browserMatch
      ? { name: browserMatch[1], version: browserMatch[2] }
      : { name: 'Unknown', version: '' };
    const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(ua);
    const os = osMatch ? osMatch.identity : 'Unknown';

    return { browser, mobile, os };
  },

  init() {
    try {
      const { browser, mobile, os } = this.getBrowserInfo();
      document.body.classList.add(`browser-${browser.name.toLowerCase()}`);
      document.body.classList.add(`browser-version-${browser.version}`);
      document.body.classList.add(`mobile-${mobile}`);
      document.body.classList.add(`os-${os.toLowerCase()}`);
    } catch (error) {
      console.error('Error detecting browser information:', error);
      document.body.classList.add(`browser-not-detect`);
      document.body.classList.add(`browser-version-not-detect`);
      document.body.classList.add(`mobile-not-detect`);
      document.body.classList.add(`os-not-detect`);
    }
  },
};

BrowserDetect.init();

window.aguadecoco = window.aguadecoco || {};
Object.assign(window.aguadecoco, {
  helpers: Object.assign(window.aguadecoco.helpers || {}, { BrowserDetect }),
});

export default {};
